import { useScreenSize } from '@/hooks/useScreenSize';
import { useConfigStore } from '@/stores';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

export const CurrentLocationIcon = (props: Props) => {
    const contrast = useConfigStore((state) => state.config.ui.contrast);
    const defaultColor = contrast ? 'black' : 'white';
    const { color = defaultColor, width = 28, height = 28, ...rest } = props;

    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;

    return (
        <svg
            width={scaleWidthPixel(numericWidth)}
            height={scaleHeightPixel(numericHeight)}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M7.73051 17.2871C4.67677 17.9803 3.7832 19.0044 3.7832 20.4884C3.7832 22.7027 8.35731 24.4978 13.9998 24.4978C19.6422 24.4978 24.2163 22.7027 24.2163 20.4884C24.2163 19.0044 23.0905 18.2476 20.0368 17.5543"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M8.7207 9.06953C8.7207 12.881 13.8964 18.2766 13.8964 18.2766C13.8964 18.2766 19.2466 13.0653 19.2775 9.06953C19.305 5.53226 16.2023 3.6416 13.8964 3.6416C11.5904 3.6416 8.7207 5.25807 8.7207 9.06953Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <circle
                cx="14.0543"
                cy="9.47711"
                r="1.48199"
                stroke={color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};
